export default __webpack_public_path__ + "static/iot-powered-taxi-fleet-management-feature-1-1dddad8c957d54e1470113f3685a981b.png";